import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

import Confirm from '../../../../base/Confirm';
import ListView from '../../../../base/ListView';
import { useDeleteFrequentPassageStickerType } from '../../../../hooks/api/frequent-passage-sticker-types/useDeleteFrequentPassageStickerType';
import { useFrequentPassageStickerTypes } from '../../../../hooks/api/frequent-passage-sticker-types/useFrequentPassageStickerTypes';
import { Event, FrequentPassageStickerType } from '../../../../hooks/api/utils/types';
import { useFilterQuery } from '../../../../hooks/useFilterQuery';
import { dateRender, defaultSuccess } from '../../../../libs/utils';

type Props = {
  event: Event;
};

export default function FrequentPassageStickerTypesList({ event }: Props) {
  const filters = useFilterQuery();
  const [listFilters, setListFilters] = React.useState(filters);
  const { mutateAsync: deleteStickerType } = useDeleteFrequentPassageStickerType();
  const { data, isLoading, refetch } = useFrequentPassageStickerTypes(event.id, { ...listFilters });

  useEffect(() => {
    refetch();
  }, [listFilters]);

  const listViewConf = {
    dataSet: data?.data,
    dataMeta: data?.meta,
    columns: [
      // {
      //     key: "id",
      //     value: "ID",
      //     sort: "id"
      // },
      {
        key: 'name',
        value: 'Sticker',
      },
      {
        key: 'requestDeadlineAt',
        value: 'Request deadline',
        render: (item: FrequentPassageStickerType) =>
          item.requestDeadlineAt ? dateRender(item.requestDeadlineAt) : null,
      },
      {
        key: 'quantity',
        value: 'Availability',
        render: (item: FrequentPassageStickerType) => `${item.availability}/${item.quantity}`,
      },
    ],
    baseFilters: filters,
    filters: [],
    actions: {
      deleteLink: true,
      deleteFunction: handleDelete,
      editLink: true,
      // detailsLink: true
    },
    url: '/admin/events/' + event.id + '/frequent-passage-sticker-types',
  };

  async function handleDelete(id: number) {
    await Confirm(
      'Are you sure you want to delete this frequent passage sticker type? This action can not be undone.',
      {
        title: 'Delete frequent passage sticker type',
        confirmStyle: 'btn-danger',
        confirmText: 'Delete',
      }
    );

    await deleteStickerType({ id });

    defaultSuccess('Frequent passage sticker type deleted.');
  }

  return (
    <div className="row">
      <div className="col-xl-12">
        <div className="m-portlet">
          <div className="m-portlet__head">
            <div className="m-portlet__head-caption">
              <div className="m-portlet__head-title">
                <h3 className="m-portlet__head-text">Frequent Passage Sticker Types</h3>
              </div>
            </div>
            <div className="m-portlet__head-tools">
              <ul className="m-portlet__nav m--margin-left-20">
                <li className="m-portlet__nav-item">
                  <Link
                    to={'/admin/events/' + event.id + '/frequent-passage-sticker-types/create'}
                    className="m-portlet__nav-link btn btn-primary m-btn m-btn--icon"
                  >
                    <span>
                      <i className="la la-plus" />
                      <span>Add sticker type</span>
                    </span>
                  </Link>
                </li>
              </ul>
            </div>
          </div>
          {isLoading && (
            <div className="m-portlet__body">
              <i className="fa fa-spinner fa-spin" /> Loading...
            </div>
          )}
          {data && <ListView keepPadding config={listViewConf} handleFilterUpdate={setListFilters} />}
        </div>
      </div>
    </div>
  );
}
